// Lista de facturas con filtros por status. Vínculo a vista pública.

import { useState } from 'react';

import { useInvoices } from '../hooks/useInvoicing';
import type { InvoiceStatus } from '../types';

const STATUS_LABEL: Record<InvoiceStatus, string> = {
  draft: 'Borrador',
  sent: 'Enviada',
  partial: 'Parcial',
  paid: 'Pagada',
  overdue: 'Vencida',
  void: 'Anulada',
};

const STATUS_OPTIONS: InvoiceStatus[] = [
  'draft', 'sent', 'partial', 'paid', 'overdue', 'void',
];

export function InvoiceList() {
  const [status, setStatus] = useState<InvoiceStatus | ''>('');
  const filters = status ? { status } : {};
  const { data, loading, error, refetch } = useInvoices(filters);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <label className="text-sm">Status:</label>
        <select
          value={status}
          onChange={(e) => setStatus((e.target.value as InvoiceStatus) || '')}
          className="border rounded px-2 py-1 text-sm"
        >
          <option value="">Todas</option>
          {STATUS_OPTIONS.map((s) => (
            <option key={s} value={s}>{STATUS_LABEL[s]}</option>
          ))}
        </select>
        <button onClick={refetch} className="text-sm underline ml-2">
          Refrescar
        </button>
      </div>

      {loading && !data ? (
        <div className="p-6 text-sm text-muted-foreground">Cargando…</div>
      ) : error ? (
        <div className="p-6 text-sm text-destructive">Error: {error}</div>
      ) : !data || data.length === 0 ? (
        <div className="p-6 text-sm text-muted-foreground">
          Sin facturas con este filtro. Crea la primera desde "Nueva".
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left border-b">
                <th className="px-3 py-2">Número</th>
                <th className="px-3 py-2">Cliente</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2">Emisión</th>
                <th className="px-3 py-2">Vence</th>
                <th className="px-3 py-2 text-right">Total</th>
                <th className="px-3 py-2 text-right">Saldo</th>
                <th className="px-3 py-2">Vencida</th>
              </tr>
            </thead>
            <tbody>
              {data.map((inv) => (
                <tr key={inv.id} className="border-b hover:bg-muted">
                  <td className="px-3 py-2 font-mono text-xs">{inv.number || '—'}</td>
                  <td className="px-3 py-2 font-medium">{inv.customer_name || '—'}</td>
                  <td className="px-3 py-2">{STATUS_LABEL[inv.status]}</td>
                  <td className="px-3 py-2 text-xs">{inv.issue_date}</td>
                  <td className="px-3 py-2 text-xs">{inv.due_date}</td>
                  <td className="px-3 py-2 text-right">
                    {inv.total} {inv.currency}
                  </td>
                  <td className="px-3 py-2 text-right">
                    {inv.balance_due} {inv.currency}
                  </td>
                  <td className="px-3 py-2 text-xs">
                    {inv.days_overdue > 0 ? `${inv.days_overdue} d` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="px-3 py-2 text-xs text-muted-foreground">
            Total: {data.length} facturas
          </div>
        </div>
      )}
    </div>
  );
}
